import { createSelector } from "reselect";

import { RootState } from "redux/reducers/rootReducer";

const getDealsState = (state: RootState) => state.deals;

export const getDealsData = createSelector(
  [getDealsState],
  (state) => state.deals
);

export const getPromotionsData = createSelector(
  [getDealsState],
  (state) => state.promotions
);

export const getBogosData = createSelector(
  [getDealsState],
  (state) => state.bogos
);

export const getDealsCategories = createSelector(
  [getDealsState],
  (state) => state.dealCategories
);

export const getMoreDealsAvailable = createSelector(
  getDealsState,
  (deals) => deals.moreDealsAvailable
);

export const getShowSeeMorePromos = createSelector(
  getDealsState,
  (deals) => deals.morePromosAvailable
);
